// To run against production server, enable the following
const UAParser = require('ua-parser-js');

const forceRunAgainstProduction = false;

const domain = window.location.host.split(':')[0];
const thisHost = window.location.protocol + '//' + domain;

const isProduction = domain.endsWith('wisdom.bot') || domain.endsWith('athenacoach.ai');
let chatHost = thisHost.replace('avatar.', 'app.');
let ttsHost = chatHost;
let contactEmail = 'hello@wisdom.bot';

if (thisHost.endsWith('athenacoach.ai')) {
    chatHost = 'https://athenacoach.ai/app';
    ttsHost = 'https://athenacoach.ai/app';
    // contactEmail = 'hello@athenacoach.ai';
}
const portSuffix = (window.location.port) ? `:${window.location.port}` : '';
let avatarUrl = thisHost + portSuffix + '/chat';

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}


let platformId = new URLSearchParams(window.location.search).get('platformId');
if (window.location.port === '3000') { // react scripts
    chatHost = `${thisHost}:5000`; // wisdombot-app
    ttsHost = `${thisHost}:8000`; // wisdombot-tts    
}

if (forceRunAgainstProduction) {
    chatHost = 'https://app.wisdom.bot'; // wisdombot-app
    ttsHost = 'https://app.wisdom.bot'; // wisdombot-tts
    if (!platformId) platformId = uuidv4();
    avatarUrl += `?platformId=${platformId}`;
}

const wsHost = ttsHost.replace('http', 'ws');

function debug(...args) {
    if (window.localStorage['_debug'] || !isProduction) {
        console.log(...args);
    }
}

const assetsUrl = 'https://wisdombot-img.s3.us-west-1.amazonaws.com';
const avatarAssetsUrl =  `${assetsUrl}/avatar`
const assetsPrefix = (window.location.protocol == 'http:' ? '.' : avatarAssetsUrl);
const avatarModel = `${assetsPrefix}/model2.glb`;
const silenceMp3 = `${assetsPrefix}/silence.mp3`;
const avatarMovementModel = `${assetsPrefix}/idle.fbx`;
const backgroundImage = `${assetsPrefix}/bg.webp`;
const backgroundImage3D = `${avatarAssetsUrl}/photo_studio_loft_hall_1k.hdr`;
const avatarPic = `${avatarAssetsUrl}/athena200w.jpg`;
const speechRecognitionDefaultTimeout = 2000;


// Safari on Mac: Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Safari/605.1.15
// Chrome on Mac: Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/115.0.0.0 Safari/537.36
function isSafariOnMac() {
    var userAgent = navigator.userAgent;
    
    // Check for Safari
    var isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
    
    // Check for Mac (but not iPhone or iPad, which are also part of the "Macintosh" platform)
    var isMac = /Macintosh/.test(userAgent) && !/iPhone|iPod|iPad/.test(userAgent);
    
    return isSafari && isMac;
}


const parser = new UAParser();
const result = parser.getResult();

// Check if the browser is Safari and the OS is iOS
const browserName = result.browser.name;
const osName = result.os.name;

//const isSafariOniOS =  === 'Safari' && result.os.name === 'iOS';


export { ttsHost, chatHost, thisHost, wsHost, avatarUrl, silenceMp3, debug, isSafariOnMac, avatarModel, avatarMovementModel, platformId, backgroundImage, avatarPic, backgroundImage3D, assetsUrl, domain, contactEmail, speechRecognitionDefaultTimeout, browserName, osName };